import { GridCloseIcon } from "@mui/x-data-grid";
import Box from "components/common/Box";
import Drawer from "components/common/Drawer";
import IconButton from "components/common/IconButton";
import Text from "components/common/Text";
import React from "react";
import { Button, Divider, InputBase, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import StarIcon from "@mui/icons-material/Star";
import { format } from "date-fns";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "350px",
    padding: "16px" /* theme.spacing(2) is usually 8 * 2 = 16px */,
  },

  header: {
    display: "flex",
    justifyContent: " space-between",
    alignItems: "center",
    marginBottom: "16px" /* theme.spacing(2) */,
  },

  feedbackreply_: {
    display: "flex",
    flexDirection: "column",
    gap: "8px" /* theme.spacing(1) */,
  },

  feedback: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px" /* theme.spacing(1) */,
    backgroundColor:
      "#f5f5f5" /* theme.palette.background.default, adjust if different */,
    borderRadius: " 4px" /* theme.shape.borderRadius */,
  },
  lableyou: {
    fontSize: "13px",
    marginLeft: "40px",
  },

  reply: {
    padding: "8px" /* theme.spacing(1) */,
    borderRadius: "4px" /* theme.shape.borderRadius */,
    border: "1px solid #e0e0e0" /* theme.palette.divider */,
    backgroundColor: "#f5f5f5",
    marginLeft: "25px",
    width: "300px",
  },

  inputreply_: {
    display: "flex",
    position: "absolute",
    bottom: "20px",
    alignItems: "center",
    marginTop: "16px" /* theme.spacing(2) */,
    border: " 1px solid #e0e0e0" /* theme.palette.divider */,
    borderRadius: "4px" /* theme.shape.borderRadius */,
  },

  input: {
    flex: "1",
    marginLeft: "8px" /* theme.spacing(1) */,
  },

  sendButton: {
    padding: "3px 20px" /* theme.spacing(1) */,
    position: "absolute",
    bottom: "20px",
    right: "20px",
  },
  dashedlinereply_: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    height: "100px" /* Adjust the height as needed */,
  },
  circle: {
    width: "10px",
    height: "10px",
    position: "relative",
    borderRadius: "50%",
    backgroundColor: " #ccc",
    top: "15px",
    right: "-8px" /* Adjust the color as needed */,
  },

  dashedline: {
    position: "relative",
    top: "34px",
    right: "-14px",
    borderRight: "2px dashed #ccc" /* Adjust the color as needed */,
  },
  reply_Container: {
    display: "flex",
    justifyContent: " space-between",
  },
}));

const DrawerFeedback = ({
  drawerOpen,
  toggleDrawer,
  rating,
  feedBackreview,
  feedbackCustomerName,
  feedBackdate,
  feedbacktime,
  handleReplyOnChange,
  handleReplySubmit,
  messageReply,
  problemText,
  feedback_reply,
  replyText,
}) => {
  const classes = useStyles();
  const date = feedback_reply.time ?? new Date().toLocaleString(); // Convert Date object to string
  console.log('first', date)
  return (
    <>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => toggleDrawer(false)}
      >
        <Box className={classes.root} role="presentation">
          <Box className={classes.header}>
            <Text style={{ fontSize: "20px" }} variant="h6">
              Reply to Feedback {feedbackCustomerName}
            </Text>
            <IconButton
              aria-label="close"
              onClick={() => toggleDrawer(false)}
              sx={{
                color: (theme) => theme.palette.grey[400],
              }}
            >
              <GridCloseIcon />
            </IconButton>
          </Box>
          <Text style={{ marginLeft: "222px" }} className={classes.lableyou}>
            {feedBackdate} {feedbacktime}
          </Text>{" "}
          <Box className={classes.feedbackreply_}>
            <Box sx={{ display: "flex" }}>
              <div className={classes.dashedline}></div>
              <span className={classes.circle}></span>

              <Box className={classes.reply}>
                {problemText && (
                  <>
                    <Text
                      sx={{ fontSize: "15px", margin: "5px 0px" }}
                    >{`Problem :${problemText}`}</Text>
                    <Divider />
                  </>
                )}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginRight: "30px",
                  }}
                >
                  <Text sx={{ fontSize: "15px" }}>{feedBackreview}</Text>
                  {rating && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <StarIcon
                        sx={{
                          fontSize: "15px",
                          color: "gold",
                          marginLeft: 0.5,
                        }}
                      />
                      <Text sx={{ fontSize: "15px", marginLeft: "10px" }}>
                        4.5
                      </Text>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
            {feedback_reply.reply !== "" && feedback_reply.reply!==null && feedback_reply.reply && (
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Text className={classes.lableyou}>You</Text>
                <Text className={classes.lableyou}>{format(new Date(date), "yyyy-MM-dd HH:mm:ss")}
                </Text>
              </Box>
            )}
            {feedback_reply.reply !== "" && feedback_reply.reply!==null && feedback_reply.reply && (
              <Box sx={{ display: "flex" }}>
                <div className={classes.circle}></div>
                <Box className={classes.reply}>
                  <Text sx={{ fontSize: "15px" }}>{feedback_reply.reply}</Text>
                </Box>
              </Box>
            )}
          </Box>
          <Box className={classes.reply_Container}>
            <Paper component="form" className={classes.inputreply_}>
              <InputBase
                value={replyText}
                className={classes.input}
                placeholder="Reply to feedback"
                inputProps={{ "aria-label": "Reply to feedback" }}
                onChange={handleReplyOnChange}
              />
            </Paper>
            <Button
              className={classes.sendButton}
              type="submit"
              variant="contained"
              style={{}}
              onClick={handleReplySubmit}
              disabled={feedback_reply.reply!==""}
            >
              Send
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default DrawerFeedback;
